module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp2-03-38ac7072accc6fa8c129b58d6373e04a.png";